import * as Yup from 'yup'

import flow from 'lodash/fp/flow'

import email from '@galo-monitor/forms/validators/email.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const forgotPasswordSchema = ({ t }) => Yup.object().shape({
  email: flow(
    email({ t }),
    required({ t })
  )(Yup.string())
})

export default forgotPasswordSchema
